<div class="newsletter-section footer-pt-20">
    <div class="container">
    </div>
</div>

<footer class="footer-area">
    <div class="copyright-area">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-6 lh-1 text-start">
                    <p>2023 © Conexa Home Technologies</p>
                </div>

            </div>
        </div>
    </div>
</footer>
